import { render, staticRenderFns } from "./CompanyKeysMultiAutocomplete.vue?vue&type=template&id=22a969b4&"
import script from "./CompanyKeysMultiAutocomplete.vue?vue&type=script&lang=ts&"
export * from "./CompanyKeysMultiAutocomplete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports